"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterObjectList = void 0;
var filterObjectList = function (list, params, defaultSearchString) {
    if (defaultSearchString === void 0) { defaultSearchString = ''; }
    var filters = params.filters;
    var filterKeyValues = Object.entries(filters);
    if (filterKeyValues.length === 0) {
        if (defaultSearchString.length > 0) {
            return list.filter(function (item) {
                return item.id &&
                    item.id.toString().includes(defaultSearchString.toLowerCase());
            });
        }
        return list;
    }
    var filtered = list.filter(function (item) {
        return filterKeyValues.every(function (_a) {
            var searchKey = _a[0], _b = _a[1], searchValue = _b === void 0 ? '' : _b;
            return isMatching(getNormalizedValue(searchKey, item, params.normalizers), searchValue);
        });
    });
    return filtered;
};
exports.filterObjectList = filterObjectList;
var isMatching = function (value, searchValue) {
    return value.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1;
};
var getNormalizedValue = function (key, value, normalizers) {
    if (normalizers.targets.fields.includes(key))
        return normalizers.targets.fn(key, value);
    if (normalizers.remarks.fields.includes(key))
        return normalizers.remarks.fn(key, value);
    if (normalizers.dates.fields.includes(key))
        return normalizers.dates.fn(key, value);
    if (normalizers.userNames.fields.includes(key))
        return normalizers.userNames.fn(key, value);
    return value[key];
};
